import React from 'react';
import { Checkbox, Popup } from 'semantic-ui-react';
import moment from 'moment';
import { dateFormat, dateTimeFormat, RestrictionTypesValues, OverrideCustomerRestrictionsCustomerId } from '@components/shared/constants';
import RestrictionTooltip from '../RestrictionTooltip/RestrictionTooltip';

const formatDate = (value, format) => (value ? moment.parseZone(value).format(format) : '');

export const getCellText = (name, row, text) => {
    switch (name) {
        case 'Date': return formatDate(row.Date, dateFormat);
        case 'HotelName': return row.HotelName || '';
        case 'RoomTypeName': return row.RoomTypeId ? row.RoomTypeName || '' : text('All');
        case 'CustomerName':
            if (row.CustomerId === OverrideCustomerRestrictionsCustomerId) return text('OverrideCustomerRestrictions');
            return row.CustomerId ? row.CustomerName || '' : '';
        case 'RateName': return row.RateId ? row.RateName || '' : text('All');
        case 'ProductName': return row.ProductId ? row.ProductName || '' : text('All');
        case 'RestrictionTypeId': {
            const type = RestrictionTypesValues[row.RestrictionTypeId];
            return type ? text(type.key) : '';
        }
        case 'MinMaxDays': return `${row.MinDays ?? ''} / ${row.MaxDays ?? ''}`;
        case 'CreateDate': return formatDate(row.CreateDate, dateTimeFormat);
        case 'IsActive': return text(row.IsActive ? 'Yes' : 'No');
        default: return '';
    }
};

export const buildColumns = ({ text, testId }) => {
    const cellFormatter = (name) => ({ row }) => {
        if (!row) return '';
        const cellTestId = `${testId}.row.${row.Id}`;
        return (
            <Popup
                content={<RestrictionTooltip row={row} testId={`${cellTestId}.tooltip`} />}
                trigger={
                    <span data-testId={`${cellTestId}.${name}`}>
                        {name === 'IsActive'
                            ? <Checkbox checked={!!row.IsActive} disabled />
                            : getCellText(name, row, text)}
                    </span>
                }
            />
        );
    };

    return [
        { name: 'Date', title: text('Date') },
        { name: 'HotelName', title: text('Hotel') },
        { name: 'RoomTypeName', title: text('RoomType') },
        { name: 'CustomerName', title: text('Customer') },
        { name: 'RateName', title: text('Rate') },
        { name: 'ProductName', title: text('Product') },
        { name: 'RestrictionTypeId', title: text('RestrictionType') },
        { name: 'MinMaxDays', title: `${text('MinNights')} / ${text('MaxNights')}` },
        { name: 'CreateDate', title: text('CreateDate') },
        { name: 'IsActive', title: text('Active') },
    ].map((column) => ({
        ...column,
        formatter: cellFormatter(column.name),
        getCellValue: (row) => (column.name === 'Date' || column.name === 'CreateDate' ? row[column.name] : getCellText(column.name, row, text)),
    }));
};
